import { RoutePreview, RoutePreviewMetrics } from "@mapmycustomers/shared/types/entity/Route";

const getRoutePreviewMetrics = ({
  polyline,
  totalDistance,
  totalDuration,
}: RoutePreview): RoutePreviewMetrics => ({ polyline, totalDistance, totalDuration });

export default getRoutePreviewMetrics;
